/**
 * Created by dv on 7/10/2017.
 */
import {
  CollectionFilters,
  LsCollectionSortCriteria,
  LsZmCollectionsMessage,
  LsZmCollectionsQuery,
  ValueList
} from '../../autogenerated/ZoomBridge';

import HashMap from './../../protocol/HashMap';
import CollectionUtil from './CollectionUtil';
export default class LsCollections {
  /**
   *
   *
   */
  constructor() {
    this._filterExpired = true;
    this._thumbImageCount = 4;
    this._pageLimit = CollectionUtil.PAGE_LIMIT;
    this._collectionId = -1;
    this._begIndex = 0;
    /**
     * @type {HashMap}
     * @private
     */
    this.filters = null;
  }

  setNameSearchString(nameMatchString) {
    this.nameMatchString = nameMatchString;
    return this;
  }

  /**
   * Sets up paging parameters
   */

  setPageLimit(pageLimit) {
    this._pageLimit = pageLimit;
    return this;
  }

  setThumbImageCount(thumbImageCount) {
    this._thumbImageCount = thumbImageCount >= 0 ? thumbImageCount : 4;
    return this;
  }

  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }

  /**
   * Select a value from the static constants present in LsCollectionSortBy class
   * @param sortByParam
   * @return {LsCollections}
   */
  setSortBy(sortByParam, sortOrder) {
    this._sortByParam = sortByParam;
    this._sortOrder = sortOrder;
    return this;
  }

  setBegIndex(begIndex) {
    this._begIndex = begIndex;
    return this;
  }

  /**
   *
   * @param {string} filerName
   * @param {Array} filterValues
   * @param {boolean} exactWordMatch
   */
  setCollectionFilters(filerName, filterValues, exactWordMatch = true) {
    if (!this.filters) {
      this.filters = new HashMap();
    }
    let valueList = this.filters.get(filerName);
    if (!valueList) {
      valueList = new ValueList();
    }
    let isDateFilter = filerName === CollectionUtil.CREATED_IN_KEY || filerName === CollectionUtil.MODIFIED_IN_KEY;

    if (!isDateFilter && exactWordMatch && filterValues && filerName !== CollectionUtil.COLLECTION_NAME_KEY) {
      filterValues = filterValues.map(function(v) {
        if (v === CollectionUtil.COLLECTION_EXPIRED) {
          return v;
        }
        return `regex:^${v}$`;
      });
    }
    valueList.setValues(filterValues);
    this.filters.put(filerName, valueList);
  }

  resetFilters() {
    this.filters = null;
  }

  /**
   * Return the count of filters.
   * @public
   * @return {int}
   */
  getFiltersCount() {
    let count = 0;
    if (this.filters) {
      this.filters.forEach(function(key, value) {
        if (value && value.getValues()) {
          count = count + value.getValues().length;
        }
      });
    }
    return count;
  }

  /**
   * resp{LsZmCollectionsResponse} of zmcollections will be used as input to onSuccess
   * @return {Promise}
   */
  run() {
    const query = new LsZmCollectionsQuery();
    const msg = new LsZmCollectionsMessage();
    msg.setBegIndex(this._begIndex);
    msg.setPageLimit(this._pageLimit);
    msg.setThumbImageCount(this._thumbImageCount);
    msg.setCollectionId(this._collectionId);
    msg.setCollectionFilters(new CollectionFilters().setFilters(this.filters));
    // msg.setFilterExpired(this._filterExpired);
    msg.setLsCollectionSortCriteria(
      new LsCollectionSortCriteria().setSortBy(this._sortByParam).setOrder(this._sortOrder)
    );
    //msg.setCollectionQueryParam(new CollectionQueryParam().setName(this.nameMatchString));
    query.message = msg;
    return query.run(true);
  }
}
